/**
 * Moldura das telas de acesso fora do login (esqueci a senha, redefinir).
 *
 * Mesmo fundo escuro e mesmo verde do login, mas num cartão único e curto —
 * essas telas têm um campo e um botão, e o painel triplo do login ficaria
 * vazio demais em volta de tão pouco.
 */
import type { ReactNode } from 'react';

import logoFull from '@/assets/logo-full.png';

export function MolduraAcesso({
  titulo,
  icone,
  children,
}: {
  titulo: string;
  icone?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div
      className="flex min-h-screen items-center justify-center p-4"
      style={{
        background:
          'linear-gradient(135deg, hsl(220, 15%, 18%) 0%, hsl(220, 12%, 12%) 100%)',
      }}
    >
      <div className="w-full max-w-sm overflow-hidden rounded-2xl bg-card text-card-foreground shadow-2xl shadow-black/40">
        <div
          className="flex flex-col items-center px-6 py-6"
          style={{
            background:
              'linear-gradient(180deg, hsl(90, 30%, 38%) 0%, hsl(100, 28%, 34%) 100%)',
          }}
        >
          <img src={logoFull} alt="Simple Hotel" className="h-20 w-auto" />
          <div className="mt-3 flex items-center gap-2">
            <span className="h-px w-6 bg-white/70" />
            <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-white">
              Administrativo
            </span>
            <span className="h-px w-6 bg-white/70" />
          </div>
        </div>
        <div className="space-y-4 p-6">
          <h1 className="flex items-center gap-2 text-lg font-semibold">
            {icone}
            {titulo}
          </h1>
          {children}
        </div>
      </div>
    </div>
  );
}
